import Bowser from 'bowser'

export const useBrowserInfo = () => {
	const userAgent = window.navigator.userAgent
	const browserInfo = Bowser.parse(userAgent)

	return {
		...browserInfo,
	}
}
